import { render, staticRenderFns } from "./xzb.vue?vue&type=template&id=13b590af&scoped=true"
import script from "./xzb.vue?vue&type=script&lang=js"
export * from "./xzb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b590af",
  null
  
)

export default component.exports